import { Reveal } from "../components/motion";
import { useSEO, usePageView } from "../lib/seo";

const Section = ({ title, children }) => (
  <Reveal>
    <section className="mb-10">
      <h2 className="font-serif text-2xl font-medium text-ink mb-3">{title}</h2>
      <div className="text-ink-soft leading-relaxed space-y-3 text-[0.95rem]">{children}</div>
    </section>
  </Reveal>
);

export default function PrivacyTerms() {
  useSEO({
    title: "Privacy & Terms — The Nanny Sleep Co.",
    description: "Terms of service, cancellation policy, privacy commitment and service boundaries for The Nanny Sleep Co.",
  });
  usePageView("/privacy-terms");

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-20 sm:py-28" data-testid="privacy-terms-page">
      <p className="overline-label mb-5">The fine print, in plain language</p>
      <h1 className="font-serif font-light text-4xl sm:text-5xl text-ink mb-12 leading-tight">Privacy & Terms</h1>

      <Section title="Service boundaries">
        <p>Advice from The Nanny Sleep Co. relates to sleep and routine — it is not a substitute for medical advice from your GP or another medical professional. If your child has an underlying health condition, consultation may not proceed; in that case you'll receive a full refund.</p>
        <p>I advise to the best of my ability, experience and training, but cannot accept liability where sleep and behavioural work does not achieve the desired result. Every child is different, and no specific outcome is guaranteed.</p>
      </Section>

      <Section title="Bookings, cancellations & refunds">
        <p>The full fee is due on booking. For consultations: cancel more than 48 hours ahead for a full refund; 24–48 hours ahead for a 50% refund; within 24 hours no refund is available — though rescheduling within one week may be possible, case by case.</p>
        <p>If The Nanny Sleep Co. cancels, you'll be offered a full refund or alternative dates. Digital products with instant access (like downloadable guides) are not eligible for refunds.</p>
      </Section>

      <Section title="Support hours">
        <p>Message support runs Monday to Saturday, 8am–6pm. I respond as soon as possible after receiving your message, subject to personal circumstances or holidays.</p>
      </Section>

      <Section title="Your privacy">
        <p>I collect only what's needed to help your family: your name, email, and the sleep details you choose to share. Your information is used solely to deliver your assessment, booking or purchase — it is never sold or shared with third parties for marketing.</p>
        <p>You can ask to see or delete your information at any time by emailing hello@thenannysleepco.com.au.</p>
        <p className="text-ink-muted text-sm italic">A full formal privacy policy is being finalised with the business's legal adviser and will be published here.</p>
      </Section>

      <Section title="Changes">
        <p>These terms may be updated from time to time; the version published here always applies.</p>
      </Section>
    </div>
  );
}
